var map = {
	"./gallery_00.jpg": 1827,
	"./gallery_01.jpg": 1828,
	"./gallery_02.jpg": 1829,
	"./gallery_03.jpg": 1830,
	"./gallery_04.jpg": 1831,
	"./gallery_05.jpg": 1832,
	"./gallery_06.jpg": 1833,
	"./gallery_07.jpg": 1834,
	"./gallery_08.jpg": 1835,
	"./gallery_09.jpg": 1836
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1826;